import { useEffect } from 'react';

export const useMutationObserver = (
  el: Element | null | undefined,
  callback: MutationCallback,
  options: MutationObserverInit = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true,
  }
) => {
  useEffect(() => {
    if (el) {
      const observer = new MutationObserver(callback);
      observer.observe(el, options);
      return () => observer.disconnect();
    }
  }, [callback, options]);
};
